<template>
  <div id="orders">
    <menu-default/>
    <div class="jumbotron jumbotron-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 class="title text-center"><i class="fa fa-file-text-o"></i> Pedidos</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div v-show="!logged" class="w-100">
          <div class="alert alert-warning" role="alert">
            <h4 class="alert-heading">Você precisa estar logado</h4>
            <p>Para gerenciar as publicações que adquiriu, você precisa fazer login no sistema.</p>
            <hr>
            <p class="mb-0"><button class="btn btn-outline-primary" @click="redirectURL({name: 'login'})">Faça seu login agora</button></p>
          </div>
        </div>
        <div v-show="logged && !loading" class="w-100" >

          <div class="w-100">
            <div class="alert alert-light" role="alert" v-show="orders.length == 0">
              <h4 class="alert-heading">Nenhum pedido encontrado</h4>
              <p>Você ainda não tem pedidos realizados. </p>
              <hr>
              <p class="mb-0"><button class="btn btn-outline-primary" @click="redirectURL({name: 'publications'})">comprar uma publicação aqui</button></p>
            </div>

            <div class="card w-100" v-if="orders.length > 0">
              <div class="card-header">Meus Pedidos </div>
              <ul class="list-group list-group-flush w-100">
                <li class="list-group-item" v-for="item in orders" v-bind:key="item.id">
                  <div class="pull-right">
                    <span :inner-html.prop="item.status | nameStatusOrder"></span>
                    <span style="color: #761c19" v-show="item.status === 'Cancelado' && item.reason !== ''">/ Reprovado</span>
                  </div>
                  <h5>Pedido #{{item.id}}</h5>
                  <small class="text-secondary">
                    Publicações: R$ {{item.total_publications | formatPrice}} |
                    <span v-show="item.shipping_value > 0">Envio: R$ {{item.shipping_value | formatPrice}} |</span>
                    Total: R$ {{item.total | formatPrice }} |
                    Data: {{item.date | formatDate}}
                    <br/>
                    <span v-for="publication in item.publications" v-bind:key="publication.id"> {{ publication.publication.name }} / </span>
                    <span v-for="expedition in item.expeditions" v-bind:key="expedition.id">Expedição: {{expedition.status.name}}</span>
                    <a class="pull-right" v-show="item.status == 'Pagamento pendente' && item.transaction_link != ''" target="_blank" :href="item.transaction_link">Imprimir Boleto</a>
                    <a class="pull-right" v-show="item.status == 'Pagamento Confirmado'" href="#" @click="redirectURL({name: 'manage'})">Gerenciar Publicações</a>
                    <a class="pull-right" v-show="item.status == 'Pagamento pendente' && item.transaction_link == ''" href="#" @click="redirectURL({name: 'payment', params: { order: item.id }})">Gerar Boleto</a>
                  </small>

                <div class="row"  v-show="item.status === 'Cancelado' && item.reason != ''">
                  <div class="form-group col-sm-12">
                    <div style="margin-top: 15px; margin-bottom: 0px;" class="alert alert-danger" role="alert">
                      <strong>PEDIDO REPROVADO</strong><br/>
                      {{ item.reason }}
                    </div>
                  </div>
                </div>
                </li>
              </ul>
            </div>
          <div class="pagination pagination-medium pagination-right"  v-if="orders.length > 0">
            <div class="pull-left">
              Pagina {{current}} de {{pages}}
            </div>
            <ul>
              <li id="previous"><a href="javascript:;" @click="getorders(previous)">Anterior</a></li>
              <li id="next"><a href="javascript:;" @click="getorders(next)">Próxima</a></li>
            </ul>
          </div>
          </div>

        </div>
      </div>
    </div>

    <footer-default/>
  </div>
</template>

<script>
  import menuDefault from "./common/menu-default"
  import footerDefault from "./common/footer-default"
  import { mapState } from 'vuex'
  import mixins from "../helpers/mixins"
  import order from '../api/order'
  export default {
    name: "Orders",
    mixins: [mixins],
    data(){
      return {
        orders: [],
        loading: true,
        user: {email: ''}
      }
    },
    computed: {
      ...mapState(['logged']),
    },
    methods: {
      getorders(page){
        if(this.logged)
          order.list(page, this.user.email, this.status).then((response)  =>  {
            this.orders = response.data.results
            this.treatPagination(page, response.data.count, response.data.pages)
            this.loading = false;
          })
      }
    },
    components: { menuDefault, footerDefault },
    mounted(){
      this.user = this.$store.state.user
      this.getorders(1)
    }
  }
</script>

<style scoped>

</style>
